
function getNote (note) {
  const error = note.type === 'error'
  const warning = note.type === 'warning'
  return {
    show: error || warning,
    tooltip: note.tooltip,
    class: error ? 'text-danger' : 'text-warning'
  }
}

export default {
  getNote
}
